import axios from "axios";
const urlLocal ="https://localhost:7101"
const urlNotebook ="http://192.168.114.83:7101"
const urlServer = "https://agpisaga.azurewebsites.net"
const urlTest = "https://agpisaga-dev.azurewebsites.net/"

const blogFetch = axios.create({
    baseURL: urlServer,  
    headers:{   
        "Content-Type": "application/json",
        "Authorization": localStorage.getItem('user') ? `Bearer ${JSON.parse(localStorage.getItem('user')).token}` : ""
    } 
});
export default blogFetch;

//upd